<nav class="navbar h-100">
    <div class="container-xl d-flex align-items-center h-100">

        <a class="navbar-brand ms-0">
            <img src="/logo_red.svg" height="25" />
        </a>

        <div class="d-flex align-items-center h-100 ms-3 me-auto gap-4">
            <a href="javascript:void(0)" (click)="openContactUsDialog()"> {{'PAGE_TITLE.CONTACT_US' | translate}} </a>
            <a target="_blank" href="https://www.aon.com/en/about/leadership-and-governance/privacy-policy"> {{'PAGE_TITLE.PRIVACY_STATEMENT' | translate}} </a>
        </div>

        <p class="m-0 me-0">
            &copy; {{year}} Aon. All rights reserved.
        </p>

    </div>

</nav>
